export const MY_ACCOUNT_URL = process.env.REACT_APP_MY_ACCOUNT_URL

//process.env.REACT_APP_API_LOCAL_ENV === 'true' ? process.env.REACT_APP_API_GATEWAY_URL : `https://${window.location.hostname}/api/`,

export const API_URL_RESOURCE = {
    // URL: process.env.REACT_APP_API_GATEWAY_URL,
    URL:
        process.env.REACT_APP_API_LOCAL_ENV === 'true'
            ? process.env.REACT_APP_API_GATEWAY_URL
            : `https://${window.location.hostname}/api/`,
    //process.env.REACT_APP_API_GATEWAY_URL,
    //URL: 'http://35.238.150.172:3435/',
    // MYACCOUNT: process.env.REACT_APP_MYACCOUNT,
    // CLIENTPROGRAM: process.env.REACT_APP_CLIENTPROGRAM,
    // CLIENTENTITY: process.env.REACT_APP_CLIENTENTITY,
    REGISTRATION_API: 'clientprogram/registerpractice',
    GETCAPTCHA_API: 'recaptcha',
}

export const GlobalSetting = {
    IS_MULTIPRACTICE: process.env.REACT_APP_MULTIPRACTICE === 'true' ? true : false,
    IS_MULTIPROGRAM: process.env.REACT_APP_MULTIPROGRAM === 'true' ? true : false,
    EnableUserManagement: process.env.REACT_APP_USERMANAGEMENT === 'true' ? true : false,
    clinicianConfig: {
        //     downloadtemplate:
        //         process.env.REACT_APP_CLINICIANDOWNLOAD === 'true' ? false : true,
        //     import: process.env.REACT_APP_CLINICIANIMPORT === 'true' ? false : true,
        //     status: process.env.REACT_APP_CLINICIANSTATUS === 'true' ? true : false,
        addClinicianFromSignup:
            process.env.REACT_APP_ADD_CLINICIAN_FROM_SIGNUP === 'true' ? true : false,
    },

    entityObject: {
        cliententityid: 0,
        cliententityname: '',
        practiceid: '',
        entitytypeid: 0,
        entitytype: '',
        clientprogramid: 0,
        clientprogramname: '',
        programid: 0,
        programhost: '',
        loadpreventusergrid: 0,
        userlist: [],
    },

    IS_POLICY_BASED: process.env.REACT_APP_POLICY_BASED === 'true' ? true : false,
}

export const DF_cliententityid = {
    cliententityid: process.env.cliententityid,
}

export const HTTP_CALL_TYPE = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
}

export const TOAST_VARIANT = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
}

export const CURRENCY_ICONS = {
    USD: 'dollar-sign',
    INR: 'rupee-sign',
}

export const builkUploadSchema = {
    columns: [
        {
            mapProperty: 'uploadeddate',
            columnLabel: 'Uploaded Data',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'filename',
            columnLabel: 'File Name',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'totalcount',
            columnLabel: 'Total Entry',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'successcount',
            columnLabel: 'Passed',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'failedcount',
            columnLabel: 'Failed',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'UploadedBy',
            columnLabel: 'Uploaded By',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'actions',
            columnLabel: 'Actions',
            actions: true,
            columnActions: [
                {
                    componentType: 'Edit',
                    actionType: 'edit',
                    buttonType: 'icon',
                    icon: 'file-download',
                },
            ],
        },
    ],
    data: {
        success: {
            result: [
                {
                    fileid: 31,
                    successcount: 1,
                    failedcount: 0,
                    totalcount: 1,
                    uploadeddate: '22/06/2020',
                    filename: 'uploadClinician.xls',
                    UploadedBy: 'John Peterson',
                },
                {
                    fileid: 30,
                    successcount: 1,
                    failedcount: 0,
                    totalcount: 1,
                    uploadeddate: '22/06/2020',
                    filename: 'uploadClinician.xls',
                    UploadedBy: 'John Peterson',
                },
                {
                    fileid: 29,
                    successcount: 0,
                    failedcount: 1,
                    totalcount: 1,
                    uploadeddate: '22/06/2020',
                    filename: 'uploadClinician.xls',
                    UploadedBy: 'John Peterson',
                },
                {
                    fileid: 28,
                    successcount: 0,
                    failedcount: 1,
                    totalcount: 1,
                    uploadeddate: '22/06/2020',
                    filename: 'uploadClinician.xls',
                    UploadedBy: 'John Peterson',
                },
            ],
        },
        error: {},
    },
}

export const testFields = {
    tabName: 'Demographic Detail',
    fields: [
        {componentType: 'RowHeader', value: 'Personal Details', cssClass: 'test'},
        {
            componentType: 'Row',
            value: [
                {
                    fieldName: 'firstname',
                    componentType: 'InputField',
                    columnName: 'fname',
                },
                {
                    fieldName: 'MiddleName',
                    componentType: 'InputField',
                    columnName: 'mname',
                },
                {
                    fieldName: 'LastName',
                    componentType: 'InputField',
                    columnName: 'lname',
                },
            ],
        },
        {
            componentType: 'Row',
            value: [
                {
                    fieldName: 'contactType',
                    componentType: 'SelectField',
                    columnName: 'contactType',
                    data: [
                        {key: 1, value: 'Primary'},
                        {key: 2, value: 'Secondary'},
                    ],
                    multiSelect: false,
                },
                {
                    fieldName: 'Role',
                    componentType: 'SelectField',
                    columnName: 'role',
                    data: [
                        {key: 1, value: 'Administrator'},
                        {key: 2, value: 'IT Director'},
                    ],
                    multiSelect: false,
                },
            ],
        },
        {componentType: 'RowHeader', value: 'Contact Type'},
        {
            componentType: 'Row',
            value: [
                {
                    fieldName: 'Email Address',
                    componentType: 'InputField',
                    columnName: 'email',
                },
                {
                    fieldName: 'Phone Number',
                    componentType: 'InputField',
                    columnName: 'phone',
                },
                {
                    fieldName: 'Alternate Phone Number',
                    componentType: 'InputField',
                    columnName: 'altPhone',
                },
            ],
        },
    ],
}

const sectionProps_asd789 = {
    tabName: 'Demographic Detail',
    cssClass: 'demographic',
    fields: [
        {
            componentType: 'Row',
            value: [
                {
                    componentType: 'MarkdownRender',
                    value: '<span>Note:<br/>This is a sample note</span>',
                    cssClass: 'demographic',
                },
            ],
        },
        {
            componentType: 'Row',
            cssClass: 'test',
            value: [
                {
                    fieldName: 'Practice Name TEST',
                    componentType: 'InputField',
                    columnName: 'practiceName',
                    cssClass: 'col-lg-6 col-md-12',
                    validations: [
                        {
                            type: 'isRequired',
                            errorText: 'Practice Name is required',
                        },
                    ],
                },
                {
                    fieldName: 'Practice Settings',
                    componentType: 'SelectField',
                    columnName: 'practiceSetting',
                    cssClass: '',
                    data: '',
                    multiSelect: false,
                },
                {
                    fieldName: 'Practice Type',
                    componentType: 'SelectField',
                    columnName: 'practiceType',
                    cssClass: '',
                    data: '',
                    multiSelect: false,
                },
                {
                    fieldName: 'Practice ID',
                    componentType: 'InputField',
                    columnName: 'practiceID',
                    cssClass: '',
                },
            ],
        },
        {
            componentType: 'RowHeader',
            value: 'Address Details',
            icon: 'map-marked-alt',
            cssClass: 'demographic',
        },
        {
            componentType: 'Row',
            value: [
                {
                    fieldName: 'Street & Number',
                    componentType: 'InputField',
                    columnName: 'streetAdddress',
                    cssClass: 'col-lg-3 col-md-6',
                },
                {
                    fieldName: 'Building/Suite/Floor',
                    componentType: 'InputField',
                    columnName: 'buildingName',
                    cssClass: 'col-lg-3 col-md-6',
                },
                {
                    fieldName: '',
                    componentType: 'StateCityZip',
                    columnName: 'stateCityZip',
                    defaultValue: [{}],
                    value: [{}],
                    cssClass: 'col-lg-6 col-md-12',
                    multiSelect: false,
                    data: '',
                    childComponents: [
                        {
                            fieldName: 'State',
                            componentType: 'SelectField',
                            columnName: 'state',
                            fetchData: false,
                            validations: [
                                {
                                    type: 'isRequired',
                                    errorText: 'State is a required field',
                                },
                            ],
                        },
                        {
                            fieldName: 'City',
                            componentType: 'SelectField',
                            columnName: 'city',
                            fetchData: false,
                            validations: [
                                {
                                    type: 'isRequired',
                                    errorText: 'City is a required field',
                                },
                            ],
                        },
                        {
                            fieldName: 'Zip Code',
                            componentType: 'InputField',
                            columnName: 'zipcode',
                            validations: [
                                {
                                    type: 'isRequired',
                                    errorText: 'Zip Code is a required field',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ],
}

const sectionProps_asd456 = {
    name: '',
    searchControlLabel: 'Search contact',
    addContactbtnLabel: 'ADD CONTACT DETAILS',
    addContactform: {
        title: 'Add Contact Details',
        fields: [
            {componentType: 'RowHeader', value: 'Personal Details'},
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'First Name',
                        componentType: 'InputField',
                        columnName: 'fname',
                    },
                    {
                        fieldName: 'Middle Name',
                        componentType: 'InputField',
                        columnName: 'mname',
                    },
                    {
                        fieldName: 'Last Name',
                        componentType: 'InputField',
                        columnName: 'lname',
                    },
                ],
            },
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'Role',
                        componentType: 'SelectField',
                        columnName: 'role',
                        data: [
                            {key: 1, value: 'Administrator'},
                            {key: 2, value: 'IT Director'},
                        ],
                        multiSelect: false,
                    },
                    {
                        fieldName: 'Contact Type',
                        componentType: 'SelectField',
                        columnName: 'contactType',
                        data: [
                            {key: 1, value: 'Primary'},
                            {key: 2, value: 'Secondary'},
                        ],
                        multiSelect: false,
                    },
                    {
                        fieldName: 'Login Name',
                        componentType: 'InputField',
                        columnName: 'loginName',
                    },
                ],
            },
            {componentType: 'RowHeader', value: 'Contact Details'},
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'Email Address',
                        componentType: 'InputField',
                        columnName: 'email',
                    },
                    {
                        fieldName: 'Phone Number',
                        componentType: 'InputField',
                        columnName: 'phoneNumber',
                    },
                    {
                        fieldName: 'Alternate Phone Number',
                        componentType: 'InputField',
                        columnName: 'altPhoneNumber',
                    },
                ],
            },
        ],
        buttons: [
            {
                componentType: 'Cancel', // For buttonType='button' , componentType will behave as label
                actionType: 'cancel',
                buttonType: 'button',
            },
            {
                componentType: 'Save',
                actionType: 'save',
                buttonType: 'button',
            },
        ],
    },
    columns: [
        {
            mapProperty: 'name',
            columnLabel: 'Name',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'role',
            columnLabel: 'Role',
        },
        {
            mapProperty: 'email',
            columnLabel: 'Email',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'phone',
            columnLabel: 'Phone',
        },
        {
            mapProperty: 'altphone',
            columnLabel: 'Alternate Phone',
        },
    ],
}

const sectionProps_asd102 = {
    clinicianSearchControlLabel: 'Search by name',
    addClinicianBtnLabel: 'ADD CLINICIAN',
    uploadClinicianBtnLabel: 'UPLOAD CLINICIAN DATA',
    downlodClinicianBtnLabel: 'Download Template',
    locationSearchControlLabel: 'Search by location',
    addlLocationBtnLabel: 'ADD LOCATION',
    clinicianColumns: [
        {
            mapProperty: 'name',
            columnLabel: 'Name',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'npi',
            columnLabel: 'NPI',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'memberId',
            columnLabel: 'Member ID',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'email',
            columnLabel: 'Email',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'phone',
            columnLabel: 'Phone',
        },
        {
            mapProperty: 'clinicianType',
            columnLabel: 'Clinician Type',
        },
        {
            mapProperty: 'actions',
            columnLabel: 'Actions',
            actions: true,
            columnActions: [
                {
                    componentType: 'Edit',
                    actionType: 'edit',
                    buttonType: 'icon',
                    icon: 'pen',
                },
                {
                    componentType: 'Delete',
                    actionType: 'delete',
                    buttonType: 'icon',
                    icon: 'trash-alt',
                },
            ],
        },
    ],

    locationColumns: [
        {
            mapProperty: 'location',
            columnLabel: 'Location',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'area',
            columnLabel: 'Area',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'address',
            columnLabel: 'Address',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'state',
            columnLabel: 'State',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'city',
            columnLabel: 'City',
        },
        {
            mapProperty: 'zip',
            columnLabel: 'Zip',
        },
        {
            mapProperty: 'tin',
            columnLabel: 'tin',
        },
        {
            mapProperty: 'actions',
            columnLabel: 'Actions',
            actions: true,
            columnActions: [
                {
                    componentType: 'Edit',
                    actionType: 'edit',
                    buttonType: 'icon',
                    icon: 'pen',
                },
                {
                    componentType: 'Delete',
                    actionType: 'delete',
                    buttonType: 'icon',
                    icon: 'trash-alt',
                },
            ],
        },
    ],

    addLocationForm: {
        title: 'Add Location',
        fields: [
            {componentType: 'RowHeader', value: 'Location Details'},
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'Location Name',
                        componentType: 'InputField',
                        columnName: 'location',
                        validations: [
                            {
                                type: 'isRequired',
                                errorText: 'Location Name cannot be left empty',
                            },
                        ],
                    },
                    {
                        fieldName: 'Urban',
                        componentType: 'InputField',
                        columnName: 'area',
                        validations: [
                            {
                                type: 'isRequired',
                                errorText: 'Urban cannot be left empty',
                            },
                        ],
                    },
                    {
                        fieldName: 'Type',
                        componentType: 'RadioSelection',
                        columnName: 'typeselecttion',
                        radioList: [
                            {
                                id: '1',
                                text: 'Full Time',
                            },
                            {
                                id: '2',
                                text: 'Part Time',
                            },
                        ],
                        alignmentType: 'H',
                        labelPlacement: 'end',
                    },
                ],
            },
            {componentType: 'RowHeader', value: 'Address Details'},
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'Address',
                        componentType: 'InputField',
                        columnName: 'address',
                    },
                    {
                        fieldName: 'Building/Suite/Floor',
                        componentType: 'InputField',
                        columnName: 'buildingsuitefloor',
                    },
                ],
            },

            {componentType: 'RowHeader', value: 'TIN Details'},
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'SElect / Enter TIN',
                        componentType: 'InputField',
                        columnName: 'tin',
                    },
                ],
            },
        ],
    },

    addClinicianForm: {
        title: 'Add Clinician',
        fields: [
            {componentType: 'RowHeader', value: 'Personal Details'},
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'Clnician Npi',
                        componentType: 'InputField',
                        columnName: 'npi',
                        validations: [
                            {
                                type: 'isRequired',
                                errorText: 'Clnician Npi cannot be left empty',
                            },
                        ],
                    },
                ],
            },

            {componentType: 'RowHeader', value: ''},
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'First Name',
                        componentType: 'InputField',
                        columnName: 'firstname',
                        validations: [
                            {
                                type: 'isRequired',
                                errorText: 'First Name cannot be left empty',
                            },
                        ],
                    },
                    {
                        fieldName: 'Middle Name',
                        componentType: 'InputField',
                        columnName: 'middlename',
                    },
                    {
                        fieldName: 'Last Name',
                        componentType: 'InputField',
                        columnName: 'lastname',
                        validations: [
                            {
                                type: 'isRequired',
                                errorText: 'Last Name cannot be left empty',
                            },
                        ],
                    },
                ],
            },

            {componentType: 'RowHeader', value: ''},
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'Date of Birth',
                        componentType: 'InputField',
                        columnName: 'dateofbirth',
                    },
                ],
            },
            {componentType: 'RowHeader', value: 'Contact Details'},
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'Email Address',
                        componentType: 'InputField',
                        columnName: 'email',
                        validations: [
                            {
                                type: 'isRequired',
                                errorText: 'Email Address cannot be left empty',
                            },
                        ],
                    },
                    {
                        fieldName: 'Phone Number',
                        componentType: 'InputField',
                        columnName: 'phone',
                        validations: [
                            {
                                type: 'isRequired',
                                errorText: 'Phone Number cannot be left empty',
                            },
                        ],
                    },
                    {
                        fieldName: 'Alternate Phone Number',
                        componentType: 'InputField',
                        columnName: 'alternatephonenumber',
                        validations: [
                            {
                                type: 'isRequired',
                                errorText: 'Alternate Phone Number cannot be left empty',
                            },
                        ],
                    },
                ],
            },

            {componentType: 'RowHeader', value: 'Professional Details'},
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'Select Clinician Type',
                        componentType: 'SelectField',
                        columnName: 'selectclinicaintype',
                        data: [
                            {key: 1, value: 'Physician'},
                            {key: 2, value: 'Other'},
                        ],
                        multiSelect: false,
                    },
                    {
                        fieldName: 'Add Designation Title',
                        componentType: 'InputField',
                        columnName: 'designationtitle',
                    },
                    {
                        fieldName: 'Select Speciality',
                        componentType: 'SelectField',
                        columnName: 'selectspeciality',
                        data: [
                            {key: 1, value: 'Neuro Surgon'},
                            {key: 2, value: 'Other'},
                        ],
                        multiSelect: false,
                    },
                ],
            },

            // {componentType: 'RowHeader', value: 'TIN Details'},
            // {
            //     componentType: 'Row',
            //     value: [
            //         {
            //             fieldName: 'SElect / Enter TIN',
            //             componentType: 'InputField',
            //             columnName: 'address',
            //         },
            //     ],
            // },
        ],
    },
}

const sectionProps_aqw456 = {
    name: '',
    searchControlLabel: 'Search TIN',
    addTinbtnLabel: 'ADD TIN',
    addTinform: {
        title: 'Add TIN',
        fields: [
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'TIN Number',
                        componentType: 'InputField',
                        columnName: 'tinNumber',
                    },
                ],
            },
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'Valid From',
                        componentType: 'InputField',
                        columnName: 'validFrom',
                    },
                    {
                        fieldName: 'Valid To',
                        componentType: 'InputField',
                        columnName: 'validTo',
                    },
                ],
            },
        ],
        buttons: [
            {
                componentType: 'Cancel', // For buttonType='button' , componentType will behave as label
                actionType: 'cancel',
                buttonType: 'button',
            },
            {
                componentType: 'Save',
                actionType: 'save',
                buttonType: 'button',
            },
        ],
    },
    columns: [
        {
            mapProperty: 'tin',
            columnLabel: 'TIN',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'validFrom',
            columnLabel: 'Valid From',
        },
        {
            mapProperty: 'validTo',
            columnLabel: 'Valid TO',
        },
    ],
}

const sectionsDetails_asd789 = [
    {
        order: 1,
        name: 'DEMOGRAPHIC DETAILS',
        componentType: 'Demographic',
        icon: 'hospital',
        sectionProps: sectionProps_asd789,
        displayPanelAction: true,
        cssClass: 'demographic-content',
    },
    {
        order: 2,
        name: 'CONTACT DETAILS',
        componentType: 'Contact',
        icon: 'id-card',
        sectionProps: sectionProps_asd456,
        displayPanelAction: false,
        cssClass: 'contact-dtl-content',
    },
    {
        order: 3,
        name: 'TIN INFORMATION',
        componentType: 'TinInformation',
        icon: 'credit-card-front',
        sectionProps: sectionProps_aqw456,
        displayPanelAction: false,
        cssClass: 'tin-dtl-content',
    },
]

const sectionsDetails_asd456 = [
    {
        order: 1,
        name: 'Clinician Detail',
        componentType: 'Clinicians',
        sectionProps: sectionProps_asd102,
        cssClass: 'clinician-dtl-content',
        icon: 'user-md',
    },
    {
        order: 2,
        name: 'Location Details',
        componentType: 'Location',
        sectionProps: sectionProps_asd102,
        cssClass: 'location-dtl-content',
        icon: 'map-marked-alt',
    },
]

const sectionProps_asd345 = {
    dataCollectionMarkDown: {
        componentType: 'Row',
        value: [
            {
                componentType: 'MarkdownRender',
                value:
                    '<b>Data Pull:</b><br/> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Eget magna fermentum iaculis eu non diam phasellus.<br/><br/><b>Data Push:</b><br/> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Eget magna fermentum iaculis eu non diam phasellus.<br/><br/><b>Other:</b><br/> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Eget magna fermentum iaculis eu non diam phasellus.<br/><br/><hr/>',
            },
        ],
    },
    DataCollectionMethods: {
        title: '',
        fields: [
            {
                fieldName: 'Which Data Collection Method will you like to implement?',
                componentType: 'RadioSelection',
                columnName: 'dataCollectionMethods',
                radioList: [
                    {
                        id: '1',
                        text: 'Data Pull',
                    },
                    {
                        id: '2',
                        text: 'Data Push',
                    },
                    {
                        id: '3',
                        text: 'Other',
                    },
                ],
                alignmentType: 'H',
                labelPlacement: 'end',
            },
        ],
    },

    addEhrtbtnLabel: 'ADD EHR DETAILS',
    addPmtbtnLabel: 'ADD PM SYSTEM',
    addListbtnLabel: 'ADD LIS',
    ehrColumns: [
        {
            mapProperty: 'ehrsystemname',
            columnLabel: 'EHR Name',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'ehrsystemversion',
            columnLabel: 'EHR Version',
        },
        {
            mapProperty: 'ehrsystemtype',
            columnLabel: 'EHR Type',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'ehrsystemhosting',
            columnLabel: 'EHR Host',
        },
        {
            mapProperty: 'actions',
            columnLabel: 'Actions',
            actions: true,
            columnActions: [
                {
                    componentType: 'Edit',
                    actionType: 'edit',
                    buttonType: 'icon',
                    icon: 'pen',
                },
                {
                    componentType: 'Delete',
                    actionType: 'delete',
                    buttonType: 'icon',
                    icon: 'trash-alt',
                },
            ],
        },
    ],

    pmColumns: [
        {
            mapProperty: 'pmsystemname',
            columnLabel: 'Practice Management System Name',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'pmsystemversion',
            columnLabel: 'Practice Management System Version',
        },
        {
            mapProperty: 'actions',
            columnLabel: 'Actions',
            actions: true,
            columnActions: [
                {
                    componentType: 'Edit',
                    actionType: 'edit',
                    buttonType: 'icon',
                    icon: 'pen',
                },
                {
                    componentType: 'Delete',
                    actionType: 'delete',
                    buttonType: 'icon',
                    icon: 'trash-alt',
                },
            ],
        },
    ],
    lisColumns: [
        {
            mapProperty: 'lisname',
            columnLabel: 'LIS Name',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'lissystemnameversion',
            columnLabel: 'System Name & Version',
        },
        {
            mapProperty: 'lisemail',
            columnLabel: 'Email',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'lisphone',
            columnLabel: 'Phone',
        },
        {
            mapProperty: 'actions',
            columnLabel: 'Actions',
            actions: true,
            columnActions: [
                {
                    componentType: 'Edit',
                    actionType: 'edit',
                    buttonType: 'icon',
                    icon: 'pen',
                },
                {
                    componentType: 'Delete',
                    actionType: 'delete',
                    buttonType: 'icon',
                    icon: 'trash-alt',
                },
            ],
        },
    ],

    addEHRform: {
        title: 'Add Electtronic Health Record (EHR) details',
        fields: [
            {componentType: 'RowHeader', value: ''},
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'Select EHR System',
                        componentType: 'SelectField',
                        columnName: 'ehrsystemid',
                        data: [
                            {key: 1, value: 'EHR'},
                            {key: 2, value: 'Other'},
                        ],
                        multiSelect: false,
                        validations: [
                            {
                                type: 'isRequired',
                                errorText: 'Name of EHR System cannot be left empty',
                            },
                        ],
                    },
                    {
                        fieldName: 'Version of EHR System',
                        componentType: 'InputField',
                        columnName: 'ehrsystemversion',
                        validations: [
                            {
                                type: 'isRequired',
                                errorText: 'Version of EHR System cannot be left empty',
                            },
                        ],
                    },
                ],
            },
            {componentType: 'RowHeader', value: ''},
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'Type of EHR',
                        componentType: 'InputField',
                        columnName: 'ehrsystemtype',
                    },
                    {
                        fieldName: 'EHR Hoisting',
                        componentType: 'InputField',
                        columnName: 'ehrsystemhosting',
                        validations: [
                            {
                                type: 'isRequired',
                                errorText: 'EHR Hoisting cannot be left empty',
                            },
                        ],
                    },
                ],
            },

            {componentType: 'RowHeader', value: ''},
            {
                fieldName:
                    'Is your EHR a complete 2016 certified EHR Technology (CEHRT)*?',
                componentType: 'RadioSelection',
                columnName: 'isCehert',
                radioList: [
                    {
                        id: '1',
                        text: 'Yes',
                    },
                    {
                        id: '2',
                        text: 'No',
                    },
                ],
                alignmentType: 'H',
                labelPlacement: 'end',
            },
            {componentType: 'RowHeader', value: ''},
            {
                fieldName: 'Rational Database Management System Used by EHR:',
                componentType: 'RadioSelection',
                columnName: 'isRationalDb',
                radioList: [
                    {
                        id: '1',
                        text: 'Yes',
                    },
                    {
                        id: '2',
                        text: 'No',
                    },
                ],
                alignmentType: 'H',
                labelPlacement: 'end',
            },
        ],
    },

    addPMform: {
        title: 'Practice Management(PM) System Information',
        fields: [
            {componentType: 'RowHeader', value: ''},
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'Name of PM System',
                        componentType: 'SelectField',
                        columnName: 'pmsystemid',
                        data: [
                            {key: 1, value: 'PM'},
                            {key: 2, value: 'Other'},
                        ],
                        multiSelect: false,
                        validations: [
                            {
                                type: 'isRequired',
                                errorText: 'Name of PM System cannot be left empty',
                            },
                        ],
                    },
                    {
                        fieldName: 'Version of PM System',
                        componentType: 'InputField',
                        columnName: 'pmsystemversion',
                        validations: [
                            {
                                type: 'isRequired',
                                errorText: 'Version of PM System cannot be left empty',
                            },
                        ],
                    },
                ],
            },
            {componentType: 'RowHeader', value: ''},
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'Specify PM System',
                        componentType: 'InputField',
                        columnName: 'pmspecifysystemname',
                        showOnKey: 'pmsystemid',
                        showForValue: 2,
                    },
                ],
            },
        ],
    },
    addLISform: {
        title: 'LIS',
        fields: [
            {componentType: 'RowHeader', value: ''},
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'Name of LIS/APIS',
                        componentType: 'SelectField',
                        columnName: 'lisid',
                        data: [
                            {key: 1, value: 'LIS'},
                            {key: 2, value: 'Other'},
                        ],
                        multiSelect: false,
                        validations: [
                            {
                                type: 'isRequired',
                                errorText: 'Name of LIS/APIS cannot be left empty',
                            },
                        ],
                    },
                    {
                        fieldName: 'Other LIS/APIS',
                        componentType: 'InputField',
                        columnName: 'lisother',
                        validations: [
                            {
                                type: 'isRequired',
                                errorText: 'Other LIS/APIS cannot be left empty',
                            },
                        ],
                    },
                ],
            },
        ],
    },

    MiscellaneousQuestion: {
        title: '',
        fields: [
            {componentType: 'RowHeader', value: ''},
            {
                fieldName:
                    'Does the practice administer patient reported outcome measure (e.g. PHQ9,etc)?',
                componentType: 'RadioSelection',
                columnName: 'isPRO',
                radioList: [
                    {
                        id: '1',
                        text: 'Yes',
                    },
                    {
                        id: '2',
                        text: 'No',
                    },
                ],
                alignmentType: 'H',
                labelPlacement: 'end',
            },
            {componentType: 'RowHeader', value: ''},
            {
                fieldName: 'If so, what is the mode of administration?',
                componentType: 'CheckBox',
                columnName: 'administrationMode',
                checkboxList: [
                    {
                        id: 1,
                        text: 'In office kiosk/laptop/iPad/eBook',
                    },
                    {
                        id: 2,
                        text:
                            'Via online portal/website using smartphone or personal computer',
                    },
                ],
                alignmentType: 'H',
                labelPlacement: 'end',
            },
        ],
    },

    saveMultiSpecAuthorizationBtnLabel: 'SAVE',
    MultiSpecAuthorization: {
        title: '',
        fields: [
            {componentType: 'RowHeader', value: ''},
            {
                fieldName: '',
                componentType: 'MarkdownRender',
                value:
                    'As Your practice is multi-specialty, you may participate in multiple registries/programs.A privilege user from your practice will be able to enroll into multiple programs.<br/> Do you wish to centrally authorize every new registrie/program participation request before the user can complete the enrolment process?',
            },
            {componentType: 'RowHeader', value: ''},
            {
                fieldName: '',
                componentType: 'CheckBox',
                columnName: 'isMultiSpecAuthorize',
                checkboxList: [
                    {
                        id: 1,
                        text:
                            'Yes, I want to authorize every new registry/program participation.',
                    },
                ],
                alignmentType: 'H',
                labelPlacement: 'end',
            },
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName:
                            'Please select designated authority from existing contact',
                        componentType: 'SelectField',
                        columnName: 'designatedAuthority',
                        data: [
                            {key: 1, value: 'John Doe(Admin)'},
                            {key: 2, value: 'Ethan Bradley'},
                            {key: 3, value: 'Carol Fisher'},
                        ],
                        multiSelect: true,
                        showOnKey: 'isMultiSpecAuthorize',
                        showForValue: 1,
                    },
                ],
            },
        ],
    },
}

const sectionsDetails_asd345 = [
    {
        order: 1,
        name: 'Multi Specialty Authorization',
        componentType: 'MultiSpecialtyAuthorization',
        sectionProps: sectionProps_asd345,
        icon: 'hospitals',
    },
    {
        order: 2,
        name: 'Reporting Information',
        componentType: 'Reporting',
        sectionProps: sectionProps_asd345,
        icon: 'cogs',
    },
    {
        order: 3,
        name: 'Miscellaneous',
        componentType: 'RegistryQuestion',
        sectionProps: sectionProps_asd345,
        icon: 'sticky-note',
    },
]

const sectionProps_arg456 = {
    agreementHeader: {componentType: 'RowHeader', value: 'Sign Agreement'},
    agreementform: {
        title: 'Agreement Information',
        fields: [
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'Please select your existing contact',
                        componentType: 'AutoCompleteField',
                        columnName: 'existingContact',
                        defaultValue: '',
                        cssClass: 'col-lg-4',
                        data: [
                            {key: 1, value: 'johndoe@practice.com'},
                            {key: 2, value: 'signatory@practice.com'},
                            {key: 3, value: 'Other'},
                        ],
                        multiSelect: false,
                    },
                    {
                        fieldName: 'Please enter your name',
                        componentType: 'InputField',
                        columnName: 'name',
                        showOnKey: 'existingContact',
                        showForCondition: 'not-empty',
                    },
                    {
                        fieldName: 'Please enter your title',
                        componentType: 'InputField',
                        columnName: 'title',
                        showOnKey: 'existingContact',
                        showForCondition: 'not-empty',
                    },
                ],
            },
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'Please enter your email address',
                        componentType: 'InputField',
                        columnName: 'emailAddress',
                        showOnKey: 'existingContact',
                        showForValue: 3,
                        cssClass: 'col-lg-4',
                    },
                    {
                        fieldName: 'Please re-enter your email address',
                        componentType: 'InputField',
                        columnName: 'reEmailAddress',
                        showOnKey: 'existingContact',
                        showForValue: 3,
                        cssClass: 'col-lg-4',
                    },
                ],
            },
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'Please select agreement signing option',
                        componentType: 'RadioSelection',
                        columnName: 'agreementSigningOption',
                        showOnKey: 'existingContact',
                        showForCondition: 'not-empty',
                        radioList: [
                            {
                                id: 1,
                                text: 'E-sign',
                            },
                            {
                                id: 2,
                                text: 'Manual sign',
                            },
                        ],
                        //defaultValue: '1',
                        alignmentType: 'H',
                        labelPlacement: 'end',
                        validations: [
                            {
                                type: 'isRequired',
                                errorText: 'Please select agreement signing option',
                            },
                        ],
                    },
                ],
            },
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'Please select agreement signing option for E-sign',
                        componentType: 'RadioSelection',
                        columnName: 'agreementSigningOptionForEsign',
                        showOnKey: 'agreementSigningOption',
                        showForValue: '1',
                        //showForCondition: 'not-empty',
                        radioList: [
                            {
                                id: 1,
                                text: 'E-sign the agreement now',
                            },
                            {
                                id: 2,
                                text: 'E-sign the agreement later',
                            },
                        ],
                        //defaultValue: '1',
                        alignmentType: 'H',
                        labelPlacement: 'end',
                        validations: [
                            {
                                type: 'isRequired',
                                errorText:
                                    'Please select agreement signing option for E-sign',
                            },
                        ],
                    },
                ],
            },
        ],
    },
    agreementNowPopop: {
        title: 'Please Review & Act on these Documents',
        fields: [{componentType: 'Row', value: []}],
        buttons: [
            {
                componentType: 'Cancel', // For buttonType='button' , componentType will behave as label
                actionType: 'cancel',
                buttonType: 'button',
            },
            {
                componentType: 'Upload',
                actionType: 'upload',
                buttonType: 'button',
            },
        ],
    },
    isManualSignProps: {
        showOnKey: 'agreementSigningOption',
        showForValue: '2',
    },
    isAgreementNowProps: {
        showOnKey: 'agreementSigningOptionForEsign',
        showForValue: '1',
    },
    ManualSignPopop: {
        title: 'Manual Upload',
        fields: [
            {componentType: 'RowHeader', value: 'Upload Signed Document / File'},
            {
                componentType: 'Row',
                value: [
                    {
                        componentType: 'Row',
                        value: [
                            {
                                fieldName: 'Upload File',
                                componentType: 'UploadBuilder',
                                columnName: 'uploadFile',
                                isDragDrop: true,
                                acceptedFiles: ['image/*', 'video/*', 'application/*'],
                            },
                        ],
                    },
                ],
            },
        ],
        buttons: [
            {
                componentType: 'Cancel', // For buttonType='button' , componentType will behave as label
                actionType: 'cancel',
                buttonType: 'button',
            },
            {
                componentType: 'Upload',
                actionType: 'upload',
                buttonType: 'button',
            },
        ],
    },
    columns: [
        {
            mapProperty: 'name',
            columnLabel: 'Name',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'agreementdate',
            columnLabel: 'Agreement Date',
        },
        {
            mapProperty: 'memberid',
            columnLabel: 'Member ID',
        },
        {
            mapProperty: 'email',
            columnLabel: 'Email',
        },
        {
            mapProperty: 'status',
            columnLabel: 'Status',
        },
        {
            mapProperty: 'actions',
            columnLabel: 'Actions',
            columnActions: [
                {
                    componentType: 'Edit',
                    actionType: 'edit',
                    buttonType: 'icon', // label/icon/button
                    showOnKey: 'status',
                    showForValue: ['Pending'],
                },
                {
                    componentType: 'Delete',
                    actionType: 'delete',
                    buttonType: 'icon', // label/icon/button
                    showOnKey: 'status',
                    showForValue: ['Pending'],
                },
                {
                    componentType: 'Preview',
                    actionType: 'preview',
                    buttonType: 'icon', // label/icon/button
                    showOnKey: 'status',
                    showForValue: ['Signed'],
                },
            ],
        },
    ],
}

const sectionsDetails_arg456 = [
    {
        order: 1,
        name: 'AGREEMENT INFORMATION',
        componentType: 'Agreement',
        sectionProps: sectionProps_arg456,
        icon: 'file-contract',
    },
]

export const milestones = {
    registry: 'AAO',
    componentType: 'Milestone',
    values: [
        {
            order: 0,
            active: true,
            disabled: false,
            label: 'Add Practice Details',
            sections: sectionsDetails_asd789,
            icon: 'pencil',
        },
        {
            order: 1,
            active: false,
            disabled: false,
            label: 'Add Clinician/Location',
            sections: sectionsDetails_asd456,
            icon: 'fal fa-lock-alt',
        },
        {
            order: 2,
            active: false,
            disabled: false,
            label: 'Sign Agreement',
            sections: sectionsDetails_arg456,
            icon: 'fal fa-lock-alt',
        },
        {
            order: 3,
            active: false,
            disabled: false,
            label: 'Complete Technical Survey',
            sections: sectionsDetails_asd345,
            icon: 'fal fa-lock-alt',
        },
        {
            order: 4,
            active: false,
            disabled: false,
            label: 'Make Payment',
            sections: [],
            icon: 'fal fa-lock-alt',
        },
    ],
}

export const signUpFormProps = {
    tabName: 'Sign Up',
    fields: [
        // { componentType: "RowHeader", icon: 'Arrow', value: "Sign Up" },
        {
            componentType: 'Row',
            value: [
                {
                    fieldName: 'First Name',
                    componentType: 'InputField',
                    columnName: 'firstname',
                    isApiInputField: true,
                    placeholder: 'Enter First Name',
                    autoFocus: true,
                    validations: [
                        {
                            type: 'isRequired',
                            errorText: 'FirstName cannot be left empty',
                        },
                    ],
                },
            ],
        },
        {
            componentType: 'Row',
            value: [
                {
                    fieldName: 'Last Name',
                    componentType: 'InputField',
                    columnName: 'lastname',
                    isApiInputField: true,
                    placeholder: 'Enter Last Name',
                    validations: [
                        {
                            type: 'isRequired',
                            errorText: 'LastName cannot be left empty',
                        },
                    ],
                },
            ],
        },
        {
            componentType: 'Row',
            value: [
                {
                    fieldName: 'User Name',
                    componentType: 'InputField',
                    columnName: 'loginname',
                    isApiInputField: true,
                    placeholder: 'Enter User Name',
                    validations: [
                        {
                            type: 'isRequired',
                            errorText: 'User Name cannot be left empty',
                        },
                        {
                            type: 'minLength',
                            value: 8,
                        },
                    ],
                },
            ],
        },
        {
            componentType: 'Row',
            value: [
                {
                    fieldName: 'Email Address',
                    componentType: 'InputField',
                    columnName: 'emailaddress',
                    isApiInputField: true,
                    placeholder: 'Enter Email Address',
                    validations: [
                        {
                            type: 'isRequired',
                            errorText: 'EmailId cannot be left empty',
                        },
                        {
                            type: 'regex',
                            value: /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/,
                            errorText: 'EmailId not valid',
                        },
                    ],
                },
            ],
        },
        {
            componentType: 'Row',
            value: [
                {
                    fieldName: 'Confirm Email Address',
                    componentType: 'InputField',
                    columnName: 'confirmemailaddress',
                    placeholder: 'Enter Confirm Email Address',
                    validations: [
                        {
                            type: 'isRequired',
                            errorText: 'Confirm EmailId cannot be left empty',
                        },
                        {
                            type: 'regex',
                            value: /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/,
                            errorText: 'Confirm EmailId not valid',
                        },
                        {
                            type: 'compareTo',
                            value: 'emailaddress',
                            errorText: 'EmailId and Confirm EmailId should be same',
                        },
                    ],
                },
            ],
        },
        {
            componentType: 'Row',
            value: [
                {
                    fieldName: 'Contact No',
                    componentType: 'InputField',
                    columnName: 'contactnumber',
                    isApiInputField: true,
                    placeholder: 'Enter Contact No',
                    validations: [
                        {
                            type: 'isRequired',
                            errorText: 'Contact cannot be left empty',
                        },
                        {
                            type: 'minLength',
                            value: 6,
                        },
                    ],
                },
            ],
        },
        {
            componentType: 'Row',
            value: [
                {
                    fieldName: 'Practice Name',
                    componentType: 'InputField',
                    columnName: 'practicename',
                    isApiInputField: true,
                    placeholder: 'Enter Practice Name',
                    validations: [
                        {
                            type: 'isRequired',
                            errorText: 'Practice Name cannot be left empty',
                        },
                        {
                            type: 'minLength',
                            value: 6,
                        },
                    ],
                },
            ],
        },
        {
            componentType: 'Row',
            value: [
                {
                    fieldName: 'Practice TIN',
                    componentType: 'InputField',
                    columnName: 'tin',
                    inputType: 'password',
                    isApiInputField: true,
                    placeholder: 'Enter Practice TIN',
                    iconType: 'InfoOutlinedIcon',
                    validations: [
                        {
                            type: 'isRequired',
                            errorText: 'Practice TIN cannot be left empty',
                        },
                        {
                            type: 'minLength',
                            value: 9,
                        },
                        {
                            type: 'maxLength',
                            value: 9,
                        },
                    ],
                },
                {
                    fieldName: 'Confirm TIN',
                    componentType: 'InputField',
                    columnName: 'confirmtin',
                    placeholder: 'Enter Confirm TIN',
                    validations: [
                        {
                            type: 'isRequired',
                            errorText: 'Confirm TIN cannot be left empty',
                        },
                        {
                            type: 'minLength',
                            value: 9,
                        },
                        {
                            type: 'maxLength',
                            value: 9,
                        },
                        {
                            type: 'compareTo',
                            value: 'tin',
                            errorText: 'PracticeTIN and ConfirmTIN should be same',
                        },
                    ],
                },
            ],
        },
    ],
}

export const loginFormProps = {
    tabName: 'Login',
    fields: [
        // { componentType: "RowHeader", icon: 'Arrow', value: "Sign Up" },
        {
            componentType: 'Row',
            value: [
                {
                    fieldName: 'User Name',
                    componentType: 'InputField',
                    columnName: 'username',
                    autoFocus: true,
                    validations: [
                        {
                            type: 'isRequired',
                            errorText: 'Username cannot be left empty',
                        },
                        {
                            type: 'minLength',
                            value: 4,
                        },
                    ],
                },
            ],
        },
        {
            componentType: 'Row',
            value: [
                {
                    fieldName: 'Password',
                    componentType: 'PasswordField',
                    columnName: 'password',
                    validations: [
                        {
                            type: 'isRequired',
                            errorText: 'Password cannot be left empty',
                        },
                        {
                            type: 'minLength',
                            value: 4,
                        },
                    ],
                },
            ],
        },
    ],
}

export const forgetPasswordProps = {
    tabName: 'Forget Password',
    fields: [
        {
            componentType: 'Row',
            value: [
                {
                    fieldName: 'User Name',
                    componentType: 'InputField',
                    columnName: 'username',
                    autoFocus: true,
                    validations: [
                        {
                            type: 'isRequired',
                            errorText: 'Username cannot be left empty',
                        },
                        {
                            type: 'minLength',
                            value: 4,
                        },
                    ],
                },
            ],
        },
        {
            componentType: 'Row',
            value: [
                {
                    fieldName: 'Email Address',
                    componentType: 'InputField',
                    columnName: 'emailaddress',
                    isApiInputField: true,
                    placeholder: 'Enter Email Address',
                    validations: [
                        {
                            type: 'isRequired',
                            errorText: 'EmailId cannot be left empty',
                        },
                        {
                            type: 'regex',
                            value: /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/,
                            errorText: 'EmailId not valid',
                        },
                    ],
                },
            ],
        },
    ],
}

export const resetPasswordFormProps = {
    tabName: 'ResetPassword',
    fields: [
        {componentType: 'RowHeader', value: 'Set Password'},
        {
            componentType: 'Row',
            value: [
                {
                    fieldName: 'Password',
                    componentType: 'PasswordField',
                    columnName: 'password',
                    label: 'Password',
                    showToggle: false,
                    validations: [
                        {
                            type: 'isRequired',
                            errorText: 'Password cannot be left empty',
                        },
                        {
                            type: 'minLength',
                            value: 4,
                        },
                        {
                            type: 'maxLength',
                            value: 10,
                        },
                    ],
                },
            ],
        },
        {
            componentType: 'Row',
            value: [
                {
                    fieldName: 'Confirm Password',
                    componentType: 'PasswordField',
                    columnName: 'confirmpassword',
                    label: 'Confirm Password',
                    showToggle: false,
                    validations: [
                        {
                            type: 'isRequired',
                            errorText: 'Password cannot be left empty',
                        },
                        {
                            type: 'compareTo',
                            value: 'password',
                            errorText: 'Password and Confirm password should be same',
                        },
                    ],
                },
            ],
        },
    ],
}

const sectionProps_SubscriptionPlan = {
    labelText: 'Please select your plan : ',
    plansList: [
        {
            plan: {
                planid: 35,
                plantype: 'EHR-Integrated',
                planname: 'gold',
                plandetail: {
                    includes: ['Message 1', 'Message 2', 'Message 3', 'Message 4'],
                    feemessage: {
                        member: 'menber msg',
                        nonmember: 'nonmember msg',
                    },
                },
                fees: {
                    member: 25000,
                    nonmember: null,
                },
            },
        },
        {
            plan: {
                planid: 11,
                planname: 'silver',
                plantype: 'EHR-Integrated',
                plandetail: {
                    includes: ['Message 1', 'Message 2', 'Message 3', 'Message 4'],
                    feemessage: {
                        member: 'menber msg',
                        nonmember: 'nonmember msg',
                    },
                },
                fees: {
                    member: 8000,
                    nonmember: null,
                },
            },
        },
        {
            plan: {
                planid: 1,
                planname: 'BasePlan',
                plantype: 'EHR-Integrated',
                plandetail: {
                    includes: ['Message 1', 'Message 2', 'Message 3', 'Message 4'],
                    feemessage: {
                        member: 'menber msg',
                        nonmember: 'nonmember msg',
                    },
                },
                fees: {
                    member: 200,
                    nonmember: 250,
                },
            },
        },
    ],
    plansList1: [
        {
            planId: 1,
            headerText: 'PRIME Registry EHR-Integrated Plan',
            priceTagList: [
                {
                    price: 360,
                    currencyIcon: '',
                    duration: 'year',
                    text: 'per enrolled clinician',
                },
            ],
            facilities: [
                {
                    text: 'Complete quality performance dashboard',
                    icon: '',
                },
                {
                    text: 'QCDR Reporting for MIPS and CPC+',
                    icon: '',
                },
            ],
        },
        {
            planId: 2,
            headerText: 'PRIME Registry Manual Entry Plan(No EHR Required)',
            planType: 'EHR-Integrated',
            priceTagList: [
                {
                    price: 360,
                    duration: 'year',
                    text: 'per enrolled clinician <br/> free for ABFM diplomates',
                },
            ],
            facilities: [
                {
                    text: 'Live Quality Dashboard',
                    icon: '',
                },
                {
                    text: 'Manual entry of data for QR reporting for MIPS',
                    icon: '',
                },
            ],
        },
        {
            planId: 3,
            headerText: 'Phate',
            priceTagText: 'Free Tool',
            facilities: [
                {
                    text:
                        'My community tool(Upload address data or select servie area on map)',
                    icon: '',
                },
                {
                    text: 'Access to Community Resource locator',
                    icon: '',
                },
            ],
        },
    ],
}

const sectionProps_SelectedClinicians = {
    searchControlLabel: 'Search by Name,NPI',
    fields: [
        {
            componentType: 'Row',
            value: [
                {
                    fieldName: 'Selected Plan',
                    componentType: 'InputField',
                    columnName: 'seelctedPlan',
                    disable: true,
                },
                {
                    fieldName: 'Plan Type',
                    componentType: 'InputField',
                    columnName: 'planType',
                    disable: true,
                },
                {
                    fieldName: 'Selected Year',
                    componentType: 'InputField',
                    columnName: 'selectYear',
                    disable: true,
                },
            ],
        },
    ],
    AmountLabelsPathProps: [
        {key: 'selectedPlan.planname', path: '0.labelBody'},
        {key: 'selectedPlan.plantype', path: '1.labelBody'},
        {key: 'enrolmentYear', path: '2.labelBody'},
        {key: 'selectedPlan.fees.member', path: '3.amount'},
        {key: 'selectedPlan.fees.nonmember', path: '4.amount'},
    ],
    AmountLabelsProps: [
        {
            labelText: 'Selected Plan',
            labelBody: '',
            category: 'label',
        },
        {
            labelText: 'Plan Type',
            labelBody: '',
            category: 'label',
        },
        {
            labelText: 'Selected Year',
            labelBody: '',
            category: 'label',
        },
        {
            labelText: 'per enrolled clinicians',
            amount: 460,
            category: 'price',
        },
        {
            labelText:
                'ABFM Diplomate Price<span style="font-size:12px">(For first 3 years)</span>',
            amount: 360,
            category: 'price',
        },
    ],
    columns: [
        {
            mapProperty: 'provider.name.firstname,provider.name.lastname',
            columnLabel: 'Name',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'provider.npi',
            columnLabel: 'NPI',
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'provider.member',
            columnLabel: 'Member',
            columnActions: [
                {
                    componentType: 'member',
                    actionType: 'check',
                    buttonType: 'icon',
                    icon: 'check',
                    color: 'green',
                    isApplySpan: 'no',
                    showOnKey: 'provider.member',
                    showForValue: [true],
                },
                {
                    componentType: 'non-member',
                    actionType: 'check',
                    buttonType: 'icon',
                    icon: 'times',
                    color: 'red',
                    isApplySpan: 'no',
                    showOnKey: 'provider.member',
                    showForValue: [false],
                },
            ],
        },
        {
            mapProperty: 'provider.fees',
            columnLabel: 'Amount',
            columnActions: [
                {
                    componentType: 'Amount',
                    actionType: 'amount',
                    buttonType: 'icon',
                    icon: 'dollar-sign',
                    showCellData: true,
                    isApplySpan: 'no',
                },
            ],
        },
        {
            mapProperty: 'provider.id',
            columnLabel: 'Actions',
            columnActions: [
                {
                    componentType: 'Delete',
                    actionType: 'delete',
                    buttonType: 'icon',
                    icon: 'trash-alt',
                },
            ],
        },
    ],
}

const sectionProps_PaymentSummary = {
    fields: [
        {
            componentType: 'Row',
            value: [
                {
                    fieldName: 'Selected Plan',
                    componentType: 'InputField',
                    columnName: 'seelctedPlan',
                    disable: true,
                },
                {
                    fieldName: 'Plan Type',
                    componentType: 'InputField',
                    columnName: 'planType',
                    disable: true,
                },
                {
                    fieldName: 'Selected Year',
                    componentType: 'InputField',
                    columnName: 'selectYear',
                    disable: true,
                },
            ],
        },
    ],
    AmountLabelsPathProps: [
        {key: 'selectedPlan.planname', path: '0.labelBody'},
        {key: 'selectedPlan.plantype', path: '1.labelBody'},
        {key: 'totalClinicians', path: '2.labelBody'},
        {key: 'enrolmentYear', path: '3.labelBody'},
        {key: 'totalAmount', path: '4.labelBody'},
        //{key: 'totalAmount', path: '5.labelBody'},
    ],
    AmountLabelsProps: [
        {
            labelText: 'Selected Plan',
            labelBody: '',
            category: 'label',
        },
        {
            labelText: 'Plan Type',
            labelBody: '',
            category: 'label',
        },
        {
            labelText: 'Total Clinicians',
            labelBody: '',
            category: 'label',
        },
        {
            labelText: 'Selected Year',
            labelBody: '',
            category: 'label',
        },
        {
            labelText: 'Total Amount',
            labelBody: '',
            category: 'label',
        },
    ],
    labels: {
        termsColumnName: 'discountplanid',
        paymentOptionColumnName: 'paymentoptionid',
        termsRadioListPath: 'fields.1.value.0.radioList',
        paymentOptionPath: 'fields.3.value.0.radioList',
        netbankingShowForValuePath: 'fields.5.showForValue',
        creditCardInputShowForValuePath: 'fields.4.showForValue',
        creditCardInputAPIKeyPath: 'fields.4.value.0.value.0.apiKey',
    },
    proceedToPay: {
        title: 'Make Payment',
        fields: [
            {
                componentType: 'Row',
                value: [
                    {
                        componentType: 'MarkdownRender',
                        value:
                            'Register for more than 1 year and get additional discount',
                    },
                ],
            },
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'Select Term:',
                        componentType: 'RadioSelection',
                        columnName: 'discountplanid',
                        //fetchData: true,
                        endPoint: 'payment/getmasterpaymentmethod',
                        radioList: [
                            {
                                id: '1',
                                text: '1 Year',
                            },
                            {
                                id: '2',
                                text: '2 Year <b>(5% discount)</b>',
                            },
                            {
                                id: '3',
                                text: '3 Year (10% discount)',
                            },
                        ],
                        alignmentType: 'H',
                        labelPlacement: 'end',
                    },
                ],
            },
            {
                componentType: 'Border',
                columnName: 'paymentmodeborder',
                style: {
                    border: '1px solid #97bcd638',
                    borderRadius: '7px',
                    backgroundColor: '#97bcd638',
                },
                value: [
                    {
                        componentType: 'Row',
                        value: [
                            {
                                componentType: 'AmountLabels',
                                columnName: 'paymentamounts',
                            },
                        ],
                    },
                ],
            },
            {
                componentType: 'Row',
                value: [
                    {
                        fieldName: 'Please select mode of payment to proceed',
                        componentType: 'RadioSelection',
                        columnName: 'paymentoptionid',
                        radioList: [
                            // {
                            //     id: '1',
                            //     text: 'Online Check(E-Check)',
                            // },
                            // {
                            //     id: '2',
                            //     text: 'Credit/Debit Card',
                            // },
                        ],
                        alignmentType: 'H',
                        labelPlacement: 'end',
                        validations: [
                            {
                                type: 'isRequired',
                                errorText: 'Please select mode of payment to proceed',
                            },
                        ],
                    },
                ],
            },
            {
                componentType: 'Border',
                columnName: 'stripe',
                showOnKey: 'paymentoptionid',
                showForValue: '2',
                value: [
                    {
                        componentType: 'Row',
                        value: [{componentType: 'CreditCardInput', apiKey: null}],
                    },
                ],
            },
            {
                componentType: 'Border',
                columnName: 'netbanking',
                showOnKey: 'paymentoptionid',
                showForValue: '1',
                skipValidateOnHide: [
                    'amountholdername',
                    'bankname',
                    'accountnumber',
                    'rautingnumber',
                    'email',
                    'amount',
                ],
                value: [
                    {
                        componentType: 'Row',
                        value: [
                            {
                                componentType: 'RowHeader',
                                value: 'Online Check (E-Check) Details',
                            },
                        ],
                    },
                    {
                        componentType: 'Row',
                        value: [
                            {
                                fieldName: 'Amount Holder Name',
                                componentType: 'InputField',
                                columnName: 'accountholdername',
                                validations: [
                                    {
                                        type: 'isRequired',
                                        errorText: 'Amount Holder Name is required',
                                    },
                                ],
                            },
                            {
                                fieldName: 'Bank Name',
                                componentType: 'InputField',
                                columnName: 'bankname',
                                validations: [
                                    {
                                        type: 'isRequired',
                                        errorText: 'Bank Name is required',
                                    },
                                ],
                            },
                            {
                                fieldName: 'Accont Number',
                                componentType: 'InputField',
                                columnName: 'accountnumber',
                                validations: [
                                    {
                                        type: 'isRequired',
                                        errorText: 'Accont Number is required',
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        componentType: 'Row',
                        value: [
                            {
                                fieldName: 'Rauting Number',
                                componentType: 'InputField',
                                columnName: 'routingnumber',
                                validations: [
                                    {
                                        type: 'isRequired',
                                        errorText: 'Rauting Number is required',
                                    },
                                ],
                            },
                            {
                                fieldName: 'Email',
                                componentType: 'InputField',
                                columnName: 'email',
                                validations: [
                                    {
                                        type: 'isRequired',
                                        errorText: 'Email is required',
                                    },
                                ],
                            },
                            {
                                fieldName: 'Amount',
                                componentType: 'InputField',
                                columnName: 'paymentamount',
                                disableOnKey: 'paymentamount',
                                disableForCondition: 'not-equal',
                                disableForConditionValue: 'Signed',
                            },
                        ],
                    },
                ],
            },
        ],
        buttons: [
            {
                componentType: 'Cancel',
                actionType: 'cancelD',
                buttonType: 'button',
                skipValidate: true,
            },
            {
                componentType: 'Clear',
                actionType: 'clear',
                buttonType: 'button',
                skipValidate: true,
            },
            {
                componentType: 'Proceed to Pay',
                actionType: 'pay',
                buttonType: 'button',
                variant: 'outlined',
            },
        ],
    },
    columns: [
        {
            mapProperty: 'transactiondate',
            columnLabel: 'Transaction Date',
            dateColumn: true,
            isSort: true,
            isFilter: true,
        },
        {
            mapProperty: 'paidbyfirstname,paidbylastname',
            columnLabel: 'Paid By',
        },
        {
            mapProperty: 'totalamount',
            columnLabel: 'Total Amount',
        },
        {
            mapProperty: 'totalclinicians',
            columnLabel: 'Total Clinicians',
        },
        {
            mapProperty: 'subscriptionplanname',
            columnLabel: 'Subscription Plan',
        },
        {
            mapProperty: 'paymentmethod',
            columnLabel: 'Payment Mode',
        },
        {
            mapProperty: 'subscriptionduration',
            columnLabel: 'Subcription Duration',
        },
        {
            mapProperty: 'transactionstatus',
            columnLabel: 'Transaction Status',
            columnActions: [
                {
                    componentType: 'DataLabel',
                    actionType: 'dataLabel',
                    buttonType: 'dataLabel',
                    dataColors: [
                        {key: 'failed', value: 'red'},
                        {key: 'pending', value: '#73de23'},
                        {key: 'Successful', value: '#73de23'},
                    ],
                },
            ],
        },
        {
            mapProperty: 'actions',
            columnLabel: 'Actions',
            columnActions: [
                {
                    componentType: 'Transaction Download',
                    actionType: 'transactiondownload',
                    buttonType: 'icon',
                    icon: 'file-download',
                },
            ],
        },
    ],
}

export const sectionsDetails_Payment = [
    {
        order: 1,
        sectionname: 'Subscription Plan',
        componentType: 'SubscriptionPlan',
        sectionProps: sectionProps_SubscriptionPlan,
        icon: 'credit-card',
    },
    {
        order: 2,
        sectionname: 'Selected Clinicians',
        componentType: 'SelectedClinicians',
        sectionProps: sectionProps_SelectedClinicians,
        icon: 'user-md',
    },
    {
        order: 3,
        sectionname: 'Payment Summary',
        componentType: 'PaymentSummary',
        sectionProps: sectionProps_PaymentSummary,
        icon: 'file-invoice-dollar',
    },
]

export const app = {
    //eslint-disable-line
    registry: 'CAP',
    logos: 'CAP_logo_new_updated.svg',
    Milestone: milestones,
    registrySpecificSettings: ' ',
    ResetPassword: resetPasswordFormProps,
    LoginForm: loginFormProps,
    SignUpForm: signUpFormProps,
    footer: {
        copyright: 'FIGmd, Inc. USA. All rights reserved.',
    },
}

export const abfm = {
    //eslint-disable-line
    registry: 'ABFM',
    logos: 'ABFM-logo.png',
    Milestone: milestones,
    registrySpecificSettings: ' ',
    ResetPassword: resetPasswordFormProps,
    LoginForm: loginFormProps,
    SignUpForm: signUpFormProps,
    footer: {
        copyright: 'FIGmd, Inc. USA. All rights reserved.',
    },
}

export const pageList = [5, 10, 15, 20]

export const HIDE_TECHNICAL_SURVEY_MYACCOUNT_FOR_PRG = process.env
    .REACT_APP_HIDE_TECHNICAL_SURVEY_MYACCOUNT_FOR_PRG
    ? process.env.REACT_APP_HIDE_TECHNICAL_SURVEY_MYACCOUNT_FOR_PRG.split(',')
    : []
